var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.show
    ? _c("div", { staticClass: "Alert" }, [
        _c("div", { staticClass: "mask" }),
        _vm._v(" "),
        _c("div", { staticClass: "popContent" }, [
          _vm.closeBtn
            ? _c("div", {
                staticClass: "closeIcon hide",
                on: { click: _vm.close }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "panels" }, [
            _c("div", { staticClass: "title" }, [_vm._v(_vm._s(_vm.title))]),
            _vm._v(" "),
            _c("div", { staticClass: "content" }, [
              _c("div", {
                staticClass: "description",
                style: { textAlign: _vm.align || "left" },
                domProps: { innerHTML: _vm._s(_vm.text) }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "buttonArea" }, [
                _c(
                  "span",
                  { staticClass: "btns flex1", on: { click: _vm.clear } },
                  [_vm._v(_vm._s(_vm.clearText))]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  { staticClass: "btns flex1 red", on: { click: _vm.confirm } },
                  [_vm._v(_vm._s(_vm.confirmText))]
                )
              ])
            ])
          ])
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-91a1af3e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-91a1af3e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/ui/confirm/index.vue
// module id = null
// module chunks = 